/**
 * LP01 Transformations Slider (MC)
 * Custom Element que sincroniza un <input type="range"> nativo con el
 * ancho del panel "antes" y la posición del handle visual del comparador.
 * Vanilla JS, sin dependencias externas, encapsulado para no chocar
 * con ningún otro script del tema Dawn.
 */

(function () {
  if (customElements.get('lp01-compare-slider-mc')) return;

  class Lp01CompareSliderMC extends HTMLElement {
    connectedCallback() {
      this.range = this.querySelector('[data-compare-range]');
      this.beforeWrap = this.querySelector('[data-compare-before-wrap]');
      this.beforeImage = this.querySelector('.lp01-transformations-slider-mc__before-image');
      this.handle = this.querySelector('[data-compare-handle]');

      if (!this.range || !this.beforeWrap || !this.handle) return;

      this._onInput = this.onInput.bind(this);
      this._onResize = this.onResize.bind(this);

      this.range.addEventListener('input', this._onInput);
      window.addEventListener('resize', this._onResize);

      this.onResize();
      this.setPosition(this.range.value);
    }

    disconnectedCallback() {
      if (this.range) this.range.removeEventListener('input', this._onInput);
      window.removeEventListener('resize', this._onResize);
    }

    onResize() {
      if (!this.beforeImage) return;
      const width = this.offsetWidth;
      this.beforeImage.style.width = width + 'px';
    }

    onInput(event) {
      this.setPosition(event.target.value);
    }

    setPosition(value) {
      const clamped = Math.min(100, Math.max(0, Number(value)));
      this.beforeWrap.style.width = clamped + '%';
      this.handle.style.left = clamped + '%';
    }
  }

  customElements.define('lp01-compare-slider-mc', Lp01CompareSliderMC);
})();
